import { getPilarOf, PILLAR_COLORS } from '../dashboard/_shared';
import "./style.scss";

const netSent = (dr) =>
  Math.round((((dr.pos || 0) - (dr.neg || 0)) / Math.max(1, dr.n)) * 100);

export default function DriverCompactRow({ driver: dr, isNeg }) {
  const net = netSent(dr);
  const pilar = getPilarOf(dr.essence, dr.metricCategory);
  return (
    <div
      key={dr.d}
      className="compDriverCompactRow"
    >
      <div className="compDriverCompactRow__info">
        <div className="compDriverCompactRow__name">
          {dr.d}
          {pilar && (
            <span
              className="compDriverCompactRow__pilar"
              style={{ color: PILLAR_COLORS[pilar] }}
            >
              ({pilar})
            </span>
          )}
        </div>
        <div className="compDriverCompactRow__meta">
          {pilar ? `${pilar} · ` : ""}
          {dr.n} menções
        </div>
      </div>
      <div className="compDriverCompactRow__score-col">
        <div
          className="compDriverCompactRow__score"
          style={{ "--row-score-color": isNeg ? "var(--color-red)" : "var(--color-green)" }}
        >
          {net > 0 ? "+" : ""}
          {net}pp
        </div>
      </div>
    </div>
  );
}
